<template>
    <div class="wework-steps-head">
        <div v-if="title" class="wework-steps-head-tit">{{ title }}</div>
        <p class="wework-steps-head-desc">
            <slot name="desc"></slot>
        </p>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },

        descTxt: {
            type: String,
            default: ''
        },

        btnDisabled: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {};
    },

    computed: {
        btnTxt() {
            return this.isLastStep ? this.$t('完成') : this.$t('下一步');
        }
    },

    methods: {
        btnClick() {
            this.$emit('btnClick');
        }
    }
};
</script>
<style scoped lang="less">
@import './steps-head.less';
</style>
